import { render, staticRenderFns } from "./CoCreationItem.vue?vue&type=template&id=671a94ff&"
import script from "./CoCreationItem.vue?vue&type=script&lang=js&"
export * from "./CoCreationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports